import { Card, Grid2, Typography } from '@mui/material';
import { useState } from 'react';
import { Check, Close } from '@mui/icons-material';
import Modal from '@mui/material/Modal';
import ButtonComponent from '../../../../../components/ButtonComponent';
import InputComponent from '../../../../../components/InputComponent';
import { backgroundColorDarkTheme } from '../../../../../styles/global.styles';

interface TemporaryReleaseModalProps {
  isOpen: boolean;
  studentName?: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: (minutes: number) => void;
}

const DEFAULT_MINUTES = 30;

const TemporaryReleaseModal = ({
  isOpen,
  studentName,
  isLoading,
  onClose,
  onConfirm,
}: TemporaryReleaseModalProps) => {
  const [minutes, setMinutes] = useState(DEFAULT_MINUTES);

  const handleConfirm = () => {
    if (minutes > 0) onConfirm(minutes);
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Card sx={style.modalStyle}>
        <Typography variant="h6">Liberação temporária de saída</Typography>
        <Typography fontSize={15} sx={{ mt: 2 }}>
          {studentName
            ? `Conceder liberação temporária para "${studentName}" sair, mesmo estando bloqueado.`
            : 'Conceder liberação temporária de saída, mesmo estando bloqueado.'}
        </Typography>

        <InputComponent
          label="Duração (minutos)"
          type="number"
          min={1}
          value={minutes}
          onChange={(e) => setMinutes(Number(e.target.value))}
          sx={{ mt: 2 }}
        />

        <Grid2 container spacing={3}>
          <Grid2>
            <ButtonComponent
              loading={isLoading}
              onClick={handleConfirm}
              disabled={minutes <= 0}
              sx={{ mt: 3 }}
              startIcon={<Check />}
            >
              Liberar
            </ButtonComponent>
          </Grid2>
          <Grid2>
            <ButtonComponent
              color="error"
              loading={isLoading}
              onClick={onClose}
              startIcon={<Close />}
              sx={{ mt: 3 }}
            >
              Cancelar
            </ButtonComponent>
          </Grid2>
        </Grid2>
      </Card>
    </Modal>
  );
};

const style = {
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    backgroundColor: backgroundColorDarkTheme,
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxWidth: '90vw',
    maxHeight: '80vh',
    overflow: 'auto',
    boxShadow: 24,
    p: 4,
  },
};

export default TemporaryReleaseModal;
